export const fieldTypes = {
    companyTypes,
    personTypes
}

export const companyTypes = [
    "Name",
    "Address1",
    "Address2",
    "Zip",
    "City",
    "OrgNo",
    "Telephone1",
    "Telephone2",
    "Telephone3",
    "Email",
    "Url",
    "CountryCode",
];

export const personTypes = [

    "Address1",
    "Address2",
    "Zip",
    "Department",
    "Title",
    "Email",
    "FirstName",
    "LastName",
    "City",
    "CountryCode",
    "Telephone1",
    "Telephone2",
    "Telephone3",
    "Email",
]